import { Route, Switch, useRouteMatch } from "react-router-dom";
import NotificationsLayout from "../pages/Notifications/NotificationsLayout";
import NotificationsSettingsPage from "../pages/Notifications/NotificationsSettingsPage";

function NotificationsSettingsPageRoutes(): JSX.Element {
  const match = useRouteMatch();

  return (
    <div className="w-full h-full">
      <Switch>
        <Route
          path={`${match.path}/settings`}
          component={NotificationsSettingsPage}
        />
        <Route path={match.path} component={NotificationsLayout} />
      </Switch>
    </div>
  );
}

export default NotificationsSettingsPageRoutes;
